import * as a from '../../actions'
import { initialState as initialStateAnswers, answersUpdate } from './Answers'
import { initialState as initialStateProgress, progressUpdate } from './Progress'

const initialState = {
  missions: [],
  selectedMission: {
    id: null,
    isSelected: false,
    image_url: null,
    description: null,
    mission_pages: [],
    needs_revision: false,
    state: 0,
  },
  answerMission: {
    id: null,
    progress: initialStateProgress,
    answer: initialStateAnswers(),
    current_user_data: {},
  },
}

const stateWithAnswers = (state, action) => ({
  ...state,
  answerMission: {
    ...state.answerMission,
    answer: answersUpdate(state.answerMission.answer, action),
  },
})

const stateWithProgress = (state, action) => ({
  ...state,
  answerMission: {
    ...state.answerMission,
    progress: progressUpdate(state.answerMission.progress, action),
  },
})

const missionUpdate = (state = initialState, { type, payload }) => {
  switch (type) {
    case a.CAMPAIGN_SELECT_SUCCEEDED:
      return { ...state,
        missions: payload.missions,
        selectedMission: initialState.selectedMission,
      }
    case a.MISSION_PRE_SELECT_SUCCEEDED:
      state.missions.map(mission =>
        mission.isSelected = payload.id === mission.id,
      )
      return { ...state, selectedMission: payload }
    case a.MISSION_HISTORY_SUCCEDED:
      return { ...state,
        selectedMission: {
          ...state.selectedMission,
          history: payload,
        },
      }
    case a.MISSION_ACCEPT_SUCCEEDED:
      return {
        ...state,
        selectedMission: {
          ...state.selectedMission,
          ...payload,
        },
        answerMission: {
          id: null,
          progress: initialStateProgress,
          answer: initialStateAnswers(),
          current_user_data: {},
        },
      }
    case a.MISSION_REVIEW_SUCCESS_FETCH:
      const { answers, mission_pages } = payload
      const new_mission_pages = []
      answers.forEach((answer) => {
        let indexMissionPage = null
        new_mission_pages.forEach((m, index) => {
          if (answer.mission_page_id === m.id) {
            indexMissionPage = index
          }
        })
        if (indexMissionPage) {
          const missionPage = new_mission_pages[indexMissionPage]

          let indexPageElement = null
          missionPage.page_elements.forEach((m, index) => {
            if (answer.page_element_id === m.id) {
              indexPageElement = index
            }
          })

          if (indexPageElement) {
            const pageElement = missionPage.page_elements[indexPageElement]

            pageElement.page_element_options.push({
              id: answer.page_element_option_selected_id,
              selected: true,
            })

            missionPage.page_elements[indexPageElement] = pageElement
          } else {
            missionPage.page_elements.push({
              ...answer,
              id: answer.page_element_id,
              page_element_options: [{
                id: answer.page_element_option_selected_id,
                selected: true,
              }],
            })
          }

          new_mission_pages[indexMissionPage] = missionPage
        } else {
          new_mission_pages.push({
            page_type: 'form',
            id: answer.mission_page_id,
            page_elements: [{
              ...answer,
              id: answer.page_element_id,
              page_element_options: [{
                id: answer.page_element_option_selected_id,
                selected: true,
              }],
            }],
          })
        }
      })
      return {
        ...state,
        answerMission: {
          ...state.answerMission,
          progress: {
            ...state.answerMission.progress,
            pages_to_answer: mission_pages,
          },
          answer: {
            ...state.answerMission.answer,
            mission_pages: new_mission_pages,
          },
        },
      }
    case a.MISSION_ANSWER_INIT:
      return stateWithProgress(
        stateWithAnswers(state, {
          type,
          payload: state.selectedMission,
        }), {
          type,
          payload: state.selectedMission,
        },
      )
    case a.PROCESS_MISSION_ANSWER_DONE:
      return stateWithAnswers(state, { type, payload })
    case a.PARTIAL_MISSION_ANSWER_DONE:
      return stateWithAnswers(state, { type, payload })
    case a.PAGE_ANSWERED:
      return stateWithProgress(state, { type, payload })
    case a.MISSION_ALERT_SHOWED:
      return stateWithProgress(state, { type, payload })
    case a.NEW_TRY_STARTED:
      return stateWithProgress(state, { type, payload })
    case a.MISSION_ANSWER_DONE_SUCCEEDED:
      return stateWithProgress(state, { type, payload })
    case a.RESET_SELECTED_MISSION:
      state.missions.map(mission =>
        mission.isSelected = false)
      return {
        ...state,
        selectedMission: initialState.selectedMission,
      }
    default:
      return state
  }
}

export default missionUpdate



// WEBPACK FOOTER //
// ./src/reducers/Missions/index.jsx